"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IntercomHelper = _interopRequireDefault(require("../IntercomHelper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var IntercomWrapper = /*#__PURE__*/function (_Component) {
  _inherits(IntercomWrapper, _Component);
  var _super = _createSuper(IntercomWrapper);
  function IntercomWrapper() {
    _classCallCheck(this, IntercomWrapper);
    return _super.apply(this, arguments);
  }
  _createClass(IntercomWrapper, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
        session = _this$props.session,
        source = _this$props.source,
        intercomId = _this$props.intercomId,
        companies = _this$props.companies,
        name = _this$props.name,
        userId = _this$props.userId,
        userHash = _this$props.userHash,
        userEmail = _this$props.userEmail;

      // set up a listener for this window event, if a page is refreshed or closed, we need
      // to update the intercomSessions, we can't depend on componentWillUnmount here
      window.addEventListener('beforeunload', IntercomWrapper.componentGracefulUnmount);

      // Update Intercom here with a new session or possible updated intercom session
      _IntercomHelper["default"].bootUpdate({
        session: session,
        intercomId: intercomId,
        source: source,
        companies: companies,
        name: name,
        userId: userId,
        intercomUserHash: userHash,
        userEmail: userEmail
      });
      // { session, intercomId, source, companies = undefined, name = undefined, userId = undefined, intercomUserHash = undefined }
      // add intercom session to any existing intercomSessions in localStorage
      // we will use amount of intercomSessions in localStorage to determine if we need to call Intercom('shutdown')
      // if a new tab or window is open, we want to track it,
      // we do so by tracking the mounting/unmounting of this IntercomWrapper
      _IntercomHelper["default"].incrementIntercomSessions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // we want to call this Class function to adjust the intercomSessions in localStorage
      // if we log out, the componentWillUnmount will be called
      IntercomWrapper.componentGracefulUnmount();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: "componentGracefulUnmount",
    value: function componentGracefulUnmount() {
      _IntercomHelper["default"].decrementIntercomSessions();

      // clean up our window event listener!!
      window.removeEventListener('beforeunload', IntercomWrapper.componentGracefulUnmount);
    }
  }]);
  return IntercomWrapper;
}(_react.Component);
IntercomWrapper.defaultProps = {
  companies: undefined,
  name: undefined,
  userHash: undefined,
  userId: undefined,
  userEmail: undefined
};
IntercomWrapper.propTypes = {
  children: _propTypes["default"].element.isRequired,
  intercomId: _propTypes["default"].string.isRequired,
  session: _propTypes["default"].object.isRequired,
  source: _propTypes["default"].string.isRequired,
  companies: _propTypes["default"].array,
  userHash: _propTypes["default"].string,
  name: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  userEmail: _propTypes["default"].string
};
var _default = exports["default"] = IntercomWrapper;